// extracted by mini-css-extract-plugin
export default {"logoCircle":"Login_logoCircle__SC8ev"};